// extracted by mini-css-extract-plugin
export var section = "cloud-module--section--sXS_x";
export var inner = "cloud-module--inner--R_Apf";
export var imgWrap = "cloud-module--imgWrap--3pOSG";
export var contentWrap = "cloud-module--contentWrap--1OtIl";
export var content = "cloud-module--content--GDV0J";
export var jsAnimInit = "cloud-module--jsAnimInit--iqBoO";
export var title = "cloud-module--title--179Fd";